import type { LoadingManager } from "three";

/** URL an asset loader gets instead of a refused one: it loads nothing. */
const REFUSED_ASSET_URL = "data:,";

const originOf = (url: string): string | null => {
  try {
    return new URL(url, globalThis.location?.href).origin;
  } catch {
    return null;
  }
};

/**
 * Keeps the files an uploaded model or material references (GLTF buffers and
 * images, MTL textures) on the origin of the model itself, so a crafted upload
 * cannot make every viewer's browser fetch from a foreign host. Embedded
 * `data:` and `blob:` URLs stay allowed. A refused URL loads nothing: a texture
 * then stays empty, a GLTF buffer fails the load.
 */
export function restrictToAssetOrigin(
  manager: LoadingManager,
  assetUrl: string,
): void {
  const allowedOrigin = originOf(assetUrl);
  if (!allowedOrigin) return;
  manager.setURLModifier((url) => {
    if (url.startsWith("data:") || url.startsWith("blob:")) return url;
    if (originOf(url) === allowedOrigin) return url;
    console.warn(`Refused asset outside the model origin: ${url}`);
    return REFUSED_ASSET_URL;
  });
}
